import { useQuery } from '@tanstack/react-query';

import { useCurrentUser } from 'hooks/selectors/useCurrentUser';
import { transitions } from 'transactions/transactionProcessPurchase';
import { denormalisedResponseEntities } from 'util/data';
import { useSdk } from 'util/sdkContext';

export const useGetTransactionsNeedingAttention = () => {
  const sdk = useSdk();
  const { currentUser } = useCurrentUser();
  const isAuthenticated = Boolean(currentUser?.id);

  return useQuery({
    enabled: isAuthenticated,
    queryKey: ['transactions-needing-attention'],
    queryFn: async () => {
      const apiQueryParams = {
        only: 'sale',
        lastTransitions: [transitions.INQUIRE, transitions.PAY],
        'fields.transaction': ['lastTransition', 'lastTransitionedAt'],
        page: 1,
        perPage: 100,
      };

      const res = await sdk.transactions.query(apiQueryParams);
      const transactions = denormalisedResponseEntities(res).filter(transaction => {
        const { lastTransition, lastTransitionedAt } = transaction.attributes;
        const isRecentInquiry =
          lastTransition === transitions.INQUIRE &&
          new Date(lastTransitionedAt) > new Date(Date.now() - 1000 * 60 * 60 * 24 * 7);

        return lastTransition !== transitions.INQUIRE || isRecentInquiry;
      });

      return transactions?.length > 0;
    },
  });
};
